import React from "react";
import Button from "../../../Utility/Button/Button";
import GlobalFilter from "../../../Utility/GlobalFilter/GlobalFilter";

const ExportsFilter = ({
  filters,
  onFilterChange,
  onDateRangeChange,
  clientOptions = [],
  projectOptions = [],
  onGenerate,
  teamOptions = [],
  userOptions = [],
  applyFilters: applyFiltersFromParent,
  /** Called after reset clears draft filters (e.g. refetch unfiltered preview) */
  onAfterReset,
}) => {
  // Normalize options: remove "All ..." sentinel values for multiselects
  const normalizedClientOptions = (clientOptions || []).filter((c) => c && c !== "All Clients");
  const normalizedTeamOptions = (teamOptions || []).filter((t) => t && t !== "All Teams");
  const normalizedUserOptions = (userOptions || []).filter((u) => {
    if (u == null) return false;
    if (typeof u === "string") return u !== "All Users";
    return u.value !== "" && u.label !== "All Users";
  });

  const handleFilterReset = () => {
    ["client", "project", "team", "user"].forEach((name) => {
      onFilterChange({ target: { name, value: [] } });
    });
    onDateRangeChange({
      startDate: null,
      endDate: null,
    });
    onAfterReset?.();
  };

  const applyFilters = () => {
    applyFiltersFromParent?.();
  };

  const fields = [
    {
      type: "dropdown",
      name: "client",
      label: "Client",
      value: filters.client || [],
      options: normalizedClientOptions,
      placeholder: "All Clients",
      searchable: true,
      multiselect: true,
    },
    {
      type: "dropdown",
      name: "project",
      label: "Project",
      value: filters.project || [],
      options: projectOptions,
      placeholder: "All Projects",
      searchable: true,
      multiselect: true,
    },
    {
      type: "dropdown",
      name: "team",
      label: "Team",
      value: filters.team || [],
      options: normalizedTeamOptions,
      placeholder: "All Teams",
      searchable: true,
      multiselect: true,
    },
    {
      type: "dropdown",
      name: "user",
      label: "User",
      value: filters.user || [],
      options: normalizedUserOptions,
      placeholder: "All Users",
      searchable: true,
      multiselect: true,
    },
    {
      type: "daterange",
      name: "dateRange",
      label: "Billing Month End",
      value: filters.dateRange,
      placeholder: "Select Date Range",
      onChange: onDateRangeChange,
    },
  ];

  return (
    <div className="w-full mb-4">
      <GlobalFilter
        listingFilter={filters}
        handleFilterChange={onFilterChange}
        handleFilterReset={handleFilterReset}
        applyFilters={applyFilters}
        fields={fields}
        columns={3}
        defaultExpanded={false}
      />
    </div>
  );
};

export default ExportsFilter;
